import { render, staticRenderFns } from "./QuizHeader.vue?vue&type=template&id=021c209e&scoped=true&"
import script from "./QuizHeader.vue?vue&type=script&lang=js&"
export * from "./QuizHeader.vue?vue&type=script&lang=js&"
import style0 from "./QuizHeader.vue?vue&type=style&index=0&id=021c209e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021c209e",
  null
  
)

export default component.exports